// This middleware will listed to a custom event that was created on the
// GenerateLink function.
export default (_, self, actions) => {
  document.addEventListener('soompi-click', (e) => {
    if (e.target.href || e.target.parentNode.href) {
      // everytime a link is clicked, let the store know
      actions.clicked()
    }
  })
  return (action, ...args) => {
    // our middle ware does not do anything
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/middleware.js